import { motion } from "framer-motion";
import { reveal, revealContainer, viewportOnce } from "../../lib/motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Rooted in Mount Eden",
    body: "Originally loved in Mount Eden, OKOME Catering now provides premium Japanese catering across Auckland — carrying the same warmth to every table we serve.",
  },
  {
    n: "02",
    title: "Freshly Prepared, Always",
    body: "Every order is freshly prepared using quality ingredients and traditional Japanese flavours. Nothing pre-made, nothing rushed — only food made with genuine care.",
  },
  {
    n: "03",
    title: "Made for Your Occasion",
    body: "Office lunches, corporate meetings, training days, birthday parties, family gatherings, community events and private celebrations — thoughtfully catered, beautifully presented.",
  },
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="bg-cream py-24 md:py-32 grain-overlay"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6 mb-20"
      >
        <motion.span
          variants={reveal}
          className="label-caps text-sage md:col-span-3"
        >
          About OKOME Catering
        </motion.span>
        <motion.h2
          variants={reveal}
          className="md:col-span-9 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-ink"
        >
          A quiet devotion to{" "}
          <span className="italic text-gold">handmade</span> Japanese food,
          shared across Auckland.
        </motion.h2>
      </motion.div>

      <div className="border-t border-border">
        {CHAPTERS.map((c) => (
          <motion.div
            key={c.n}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 py-10 border-b border-border group"
          >
            <div className="md:col-span-2 font-serif text-3xl md:text-4xl text-gold">
              {c.n}
            </div>
            <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-ink">
              {c.title}
            </h3>
            <p className="md:col-span-6 text-ink/70 leading-relaxed md:text-lg">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
